module.exports = __webpack_public_path__ + "static/img/data_upload_success.d1698b3f.png";